module.exports = __webpack_public_path__ + "img/js-2.0c7ad750.jpg";